// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13401":"2296822e","60081":"79fb568e","82584":"9b78ccd7"}[chunkId] + ".chunk.css";
};